import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { TrustResourceUrlPipe } from '@finder/shared/utils/pipes/trust-resource-url/trust-resource-url.pipe';

const PLAYER_URL = '/features/pixie';

@Component({
    selector: 'finder-player-block',
    templateUrl: './player-block.component.html',
    styleUrls: ['./player-block.component.scss'],
    standalone: true,
    imports: [
        TrustResourceUrlPipe,
        CommonModule
    ]
})
export class PlayerBlockComponent implements OnInit {
    @Input() playerId: string;

    public url: string;

    constructor() { }

    ngOnInit() {
        this.url = `${PLAYER_URL}?id=${this.playerId}`;
    }
}
